import { ExternalDashboardPortalForm } from '../types';
import { vendorContactRole } from '../../../../utils';

export const externalDashboardPortalDefaultConfig: ExternalDashboardPortalForm = {
  dashboards: [],
};

export const externalDashboardPortalDefaultHiddenFor: string[] = [
  vendorContactRole.it_admin,
  vendorContactRole.executive,
  vendorContactRole.sales_mgr,
  vendorContactRole.sales_rep,
  vendorContactRole.support_person,
];
